import request from '@/utils/request'

//验证经营权信息
export function checkRightInfo(data) {
    return request({
        url: '/register/rightInfo',
        method: 'post',
        data
    })
}

//验证注册信息
export function checkRegisterInfo(data) {
    return request({
        url: '/register/registerInfo',
        method: 'post',
        data
    })
}

//保存注册信息
export function saveRegisterInfo(data) {
    return request({
        url: '/register/registerSave',
        method: 'post',
        data
    })
}

//未登录获取代办处信息
export function getMiAgentInfo(params) {
    return request({
        url: '/register/miAgentInfo',
        method: 'get',
        params
    })
}

// 验证用户编号
export function getPersonInfo(query) {
    return request({
        url: '/common/personInfo',
        method: 'get',
        params: query
    })
}

//未登录获取经销商信息
export function getMiMemberInfo(params) {
    return request({
        url: '/register/miMemberInfo',
        method: 'get',
        params
    })
}

//获取验证码
export function fetchCaptcha(params) {
    return request({
        url: '/captcha',
        method: 'get',
        params
    })
}

export function fetchConfig(query) {
    return request({
        url: '/config',
        method: 'get',
        params: query
    })
}

export function fetchHomepage() {
    return request({
        url: '/index',
        method: 'get'
    })
}

export function fetchRegions() {
    return request({
        url: '/regions',
        method: 'get'
    })
}

export function fetChildRegions(query) {
    return request({
        url: '/getChildRegionsToMap',
        method: 'get',
        params: query
    })
}

export function getChildRegionsTo(query) {
    return request({
        url: '/getChildRegionsTo',
        method: 'get',
        params: query
    })
}

export function getAlRegionsCode(query) {
    return request({
        url: '/getAlRegionsCode',
        method: 'get',
        params: query
    })
}

export function getAlRegionsIdList(query) {
    return request({
        url: '/getAlRegionsIdList',
        method: 'get',
        params: query
    })
}

// //查询用户余额
// export function fetchNumbers() {
//   return request({
//     url: '/account/getFiAcBalance',
//     method: 'get'
//   })
// }
// //经销商  查询首页信息
// export function levelInfo() {
//   return request({
//     url: '/levelInfo',
//     method: 'get'
//   })
// }
// //点击下载App
// export function downAppLocal(data) {
//   return request({
//     url: '/downApp',
//     method: 'post',
//     data
//   })
// }

//get期次
export function getwWeek(query) {
    return request({
        url: '/getwWeek',
        method: 'get',
        params: query
    })
}

// //get币种
// export function getPayMoneyCurrency(query) {
//   return request({
//     url: '/getPayMoneyCurrency',
//     method: 'get',
//     params: query
//   })
// }

//获取各类信息
export function getAllMessage(query) {
    return request({
        url: '/getAllMessage',
        method: 'get',
        params: query
    })
}

//获取当前期次
export function fetchCurrentWeek(query) {
    return request({
        url: '/getCurrentWweek',
        method: 'get',
        params: query
    })
}

// 获取本位货币(支付币种)
export function alCurrencyByUser(query) {
    return request({
        url: '/common/alCurrencyByUser',
        method: 'GET',
        params: query
    })
}

// 公司收款账户
export function bankList(query) {
    return request({
        url: 'common/bankList',
        method: 'GET',
        params: query
    })
}

// 查询已过期次  经销商/代办处
export function periodsHistory(query) {
    return request({
        url: 'common/periodsHistory',
        method: 'GET',
        params: query
    })
}

//账户合计 经销商代办处公用
export function accountBalanceSum(query) {
    return request({
        url: '/account/balanceSum',
        method: 'get',
        params: query
    })
}

// 忘记登录密码重置
export function resetLoginPassword(data) {
    return request({
        url: '/resetLoginPassword',
        method: 'post',
        data
    })
}
// 获取12月0点位促销
export function afnAugustPromotion(query) {
    return request({
        url: 'common/afnAugustPromotion',
        method: 'get',
        params: query
    })
}

